import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["viewBox"]
const _hoisted_2 = { "clip-path": "url(#clip0_2267_22594)" }
const _hoisted_3 = ["fill"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_2267_22594" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "13",
      height: "6",
      fill: "white",
      transform: "translate(0 13.5) rotate(-90)"
    })
  ])
], -1)

import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'upArrowVectorIcon',
  props: {
  color: {
    type: String as PropType<string>,
    default: "#211F58",
  },
  width: {
    type: Number as PropType<number>,
    default: 6,
  },
  height: {
    type: Number as PropType<number>,
    default: 14,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    style: _normalizeStyle(`width: ${__props.width}; height: ${__props.height}`),
    viewBox: `0 0 ${__props.width} ${__props.height}`,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    _createElementVNode("g", _hoisted_2, [
      _createElementVNode("path", {
        d: "M2.2729 0.831457L0.272905 4.16479C0.212893 4.26601 0.180741 4.3813 0.179713 4.49897C0.178685 4.61663 0.20882 4.73248 0.267054 4.83472C0.325289 4.93697 0.409549 5.02199 0.511275 5.08113C0.613001 5.14027 0.728569 5.17144 0.846239 5.17146L1.66624 5.17146C1.71044 5.17146 1.75283 5.18902 1.78409 5.22027C1.81535 5.25153 1.8329 5.29392 1.8329 5.33812L1.8329 12.0781C1.8329 12.3433 1.93826 12.5977 2.1258 12.7852C2.31333 12.9728 2.56769 13.0781 2.8329 13.0781C3.09812 13.0781 3.35247 12.9728 3.54001 12.7852C3.72755 12.5977 3.8329 12.3433 3.8329 12.0781L3.8329 5.33812C3.8329 5.29392 3.85046 5.25153 3.88172 5.22027C3.91298 5.18902 3.95537 5.17146 3.99957 5.17146L4.8329 5.17146C4.95104 5.17125 5.06699 5.13967 5.1689 5.07992C5.27081 5.02018 5.35502 4.93443 5.41291 4.83146C5.46937 4.73182 5.49922 4.61932 5.49957 4.50479C5.49954 4.38514 5.4673 4.26769 5.40624 4.16479L3.40624 0.831457C3.34721 0.731976 3.26331 0.649565 3.16279 0.592325C3.06227 0.535086 2.94858 0.504987 2.8329 0.504987C2.71723 0.504987 2.60354 0.535086 2.50302 0.592325C2.4025 0.649565 2.3186 0.731976 2.25957 0.831457L2.2729 0.831457Z",
        fill: __props.color
      }, null, 8, _hoisted_3)
    ]),
    _hoisted_4
  ], 12, _hoisted_1))
}
}

})